import {
  Category,
  HelpOutline,
  Movie,
  Person,
  Menu,
  DescriptionOutlined,
} from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import KnowQuestHomeLogo from '../../../../assets/images/logo.png';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ContactlessIcon from '@mui/icons-material/Contactless';
import TocIcon from '@mui/icons-material/Toc';

export default function Sidebar({ isSidebarOpen, toggleSidebar }) {
  const handleNavLinkClick = () => {
    if (window.innerWidth < 768 && isSidebarOpen) {
      // Close the sidebar only on phones (below 768px)
      toggleSidebar();
    }
  };

  return (
    <aside
      className={`h-screen bg-white border-r dark:bg-gray-900 dark:border-gray-700 flex flex-col items-center p-4 transition-all duration-300 ${
        isSidebarOpen ? 'w-78' : 'w-0 hidden'
      } md:w-64`}
    >
      {/* Sidebar Logo */}
      <a href="/" className="flex items-center">
        <img
          src={KnowQuestHomeLogo}
          className="h-16 w-16 mb-4"
          alt="KnowQuest"
        />
      </a>

      <a
        href="/"
        className={`text-xl font-bold text-gray-800 dark:text-white ${
          isSidebarOpen ? 'block' : 'hidden'
        } md:block`}
      >
        KnowQuest
      </a>

      <div className="flex flex-col justify-between flex-1 mt-6">
        <nav className="space-y-4">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <Menu className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Dashboard
            </span>
          </NavLink>

          <NavLink
            to="/admin/users"
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <Person className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Accounts
            </span>
          </NavLink>

          <NavLink
            to="/admin/ratings"
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <Movie className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Ratings
            </span>
          </NavLink>

          <NavLink
            to="/admin/questions"
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <HelpOutline className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Questions
            </span>
          </NavLink>

          <NavLink
            to="/admin/category"
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <Category className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Rating Category
            </span>
          </NavLink>

          <NavLink
            to="/admin/content"
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <TocIcon className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Content Managment
            </span>
          </NavLink>

          <NavLink
            to="/admin/policies"
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <DescriptionOutlined className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Policies
            </span>
          </NavLink>

          <NavLink
            to="/admin/company-question"
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <ContactSupportIcon className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Company Questions
            </span>
          </NavLink>

          <NavLink
            to="/admin/contactus"
            className={({ isActive }) =>
              `flex items-center justify-start px-2 py-2 rounded-md transition-colors duration-300 ${
                isActive
                  ? 'bg-[#00008b] text-white'
                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200'
              }`
            }
            onClick={handleNavLinkClick}
          >
            <ContactlessIcon className="text-2xl" />
            <span
              className={`ml-4 font-medium ${isSidebarOpen ? 'inline' : 'hidden'} md:inline`}
            >
              Contact Us Data
            </span>
          </NavLink>
        </nav>
      </div>
    </aside>
  );
}
